import React, { Component } from "react"
import { verifyOTP, verifyOTPCorporate, resendCode } from "../../BackendServices/registrationAPI"
import { withTranslation } from "react-i18next"
import Description from "../common/Description"
import TextInput from "../common/TextInput"
import BillingAccount from "./BillingAccount"
import SuccessScreen from "./SuccessScreen"
import { encrypt } from "../../BackendServices/generic"
import ErrorAlert from "../common/ErrorAlert"
import AddLineDetails from "./AddLineDetails"
import SpecificExceptions from "../../BackendServices/specific-exceptions"

class ActivationCode extends Component {
    state = {
        code: '',
        errors: { code: '' },
        formIsValid: false,
        isSuccess: false,
        billingNumbers: [],
        genericError: null,
        loading: false,
        isAddLineStep: false,
        errorType: { codeClassName: '' }
    }

    handleValidation = async e => {
        e.persist();
        let errors = {};
        let errorType = {};
        let formIsValid = false;

        if (e.target.name === 'code') {
            if (e.target.value === null || e.target.value === '') {
                errors['code'] = "required";
                errorType['codeClassName'] = "validation-error"
            }
        }

        if ((JSON.stringify(errors) === '{}') && this.state.code !== '') {
            formIsValid = true
        }

        this.setState({
            formIsValid: formIsValid,
            errors: errors,
            errorType: errorType
        });

    }

    handaleSubmit = async (e) => {
        e.preventDefault();

        if (this.state.formIsValid) {
            if (this.props.from === 'addLine') {
                await this.verifyOTP();
            } else {
                await this.verifyOTPCorporate();
            }
        }
    }

    verifyOTP = async (e) => {
        let requestBody = {
            "transactionId": this.props.transactionId,
            "verificationCode": this.state.code
        }
        await this.setState({
            loading: true
        })

        try {
            let result = await verifyOTP(requestBody)
            this.setState({
                isSuccess: true,
                loginUrl: result.loginUrl,
                loading: false
            })
        } catch (error) {
            if (error instanceof SpecificExceptions && error.code === 'MAPI-024') {
                this.setState({
                    isAddLineStep: true,
                    loading: false
                })
            } else {
                this.setState({
                    genericError: error.message,
                    loading: false
                })
            }
        }
    }

    verifyOTPCorporate = async (e) => {
        let requestBody = {
            "transactionId": this.props.transactionId,
            "verificationCode": this.state.code
        }
        await this.setState({
            loading: true
        })

        try {
            let result = await verifyOTPCorporate(requestBody)
            this.setState({
                transactionId: result.transactionId,
                isSuccess: true,
                billingNumbers: result.billingNumbers,
                loading: false
            })
        } catch (error) {
            this.setState({
                genericError: error.message,
                loading: false
            })
        }
    }

    handleChange = async e => {
        e.persist();
        await this.setState({
            [e.target.name]: e.target.value,
        })

        this.handleValidation(e);
    }

    resendCode = async e => {
        let requestBody = {
            "msisdn": encrypt(this.props.msisdn),
            "userType": this.props.from === 'addLine' ? "consumer" : "corporate"
        }
        let result = await resendCode(requestBody)
        if (result.status.code === 'MAPI-000') {
            this.setState({
                code: '',
                formIsValid: false
            })
        }
    }

    render() {
        const { t, apFirstName } = this.props;

        return (
            <>
                {this.state.loading && <div className="loading">Loading&#8230;</div>}

                {!this.state.isSuccess && !this.state.isAddLineStep && (
                    <>
                        <div className="loginIntroTextContainer">
                            <h3>{t("hello")} {apFirstName},</h3>
                            <p className="headerdescription">{t('code_desc')} {this.props.msisdn}</p>
                        </div>
                        <div className="tabs">
                            <div className="tab-content">
                                {this.state.genericError && (
                                    <>
                                        <ErrorAlert error={this.state.genericError} />
                                        <div style={{ display: "none" }} className={this.state.genericError ? "api-error" : ""}></div>
                                    </>
                                )}
                                <form onSubmit={this.handaleSubmit} id={"activation-code-form"}>
                                    <TextInput id="code" className='verificationCode-text' label={t("enter_verification_code")} name={"code"} value={this.state.code} type={"text"} error={this.state.errors.code} errorType={this.state.errorType.codeClassName} handleChange={this.handleChange} />

                                    <div className="formButtonGroup activationcodeButton">
                                        <button id="activationCode-SubmitBtn" type="submit" className="btn min_outlin_btn active" disabled={!this.state.formIsValid}>
                                            {t("continue_btn")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                        </button>

                                        <button id="resendCode-SubmitBtn" type="button" className="btn min_outlin_btn" onClick={this.resendCode} >
                                            {t("request_new_code")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </>
                )}
                {(this.state.isSuccess && this.props.from !== 'addLine') && (
                    <BillingAccount
                        redirectURL={this.props.redirectURL}
                        transactionId={this.props.transactionId}
                        billingNumbers={this.state.billingNumbers}
                        {...this.props}
                    />
                )}

                {(this.state.isSuccess && this.props.from === 'addLine') && <SuccessScreen description={"enjoy_of_our_services"} loginUrl={this.state.loginUrl} />}

                {this.state.isAddLineStep && <AddLineDetails redirectURL={this.props.redirectURL} transactionId={this.props.transactionId} clientInfo={this.props.clientInfo} clientId={this.props.clientId} />}

            </>
        )
    }
}

export default withTranslation()(ActivationCode);
